import {
  Button,
  ConfigProvider,
  Dropdown,
  Menu,
  Modal,
  Space,
  theme,
} from "antd";
import ReactECharts from "echarts-for-react";
import { useEffect, useState } from "react";
import { MoreOutlined, CloseOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
import { getAdjustedDate, isExactMultipleOf24Hours } from "../CommonFunctions";
import { adjustTimeByFiveHoursThirtyMinutes, calculateDateRangeFromDate } from "../../../Utils/DateConverstion";
import { TransformVcbConsumptionToStackedBarChart } from "../chartdata.transformers";
import { APIConstants } from "../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";

export default function Chart1(props) {
  var series = props.series;
  var style = props.style;
  const [data, setData] = useState([]);
  const { makeRequest } = useStoreUpdaterWithAPI();
  var title = props.title ? props.title : "Sample Title";
  const [error, setError] = useState("");
  const correctDate = new Date(getAdjustedDate());
  // console.log(correctDate)
 
  // Default dates with time set to 6:30 AM
  const defaultToDate = dayjs(correctDate).subtract(1, "days")
  .hour(6)
  .minute(30)
  .second(0);;
  const defaultFromDate = dayjs(correctDate)
    .subtract(8, "days")
    .hour(6)
    .minute(30)
    .second(0);
  const [toDate, setToDate] = useState(dayjs(correctDate).hour(6).minute(30).second(0));
  const [fromDate, setFromDate] = useState(dayjs(correctDate)
  .subtract(7, "days")
  .hour(6)
  .minute(30)
  .second(0));
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(true); // New loading state
  const [open, setOpen] = useState(false);

  // if (!style) {
  //   style = { width: "100%",height:"400%",border:"2px solid white"}
  // }
  useEffect(() => {
    getTitleStyle();
  }, []);

  const items = [
    {
      label: (
        <p className="" onClick={() => setOpen(!open)}>
          TV
        </p>
      ),
      key: "0",
    },
    {
      label: <p> Other Option</p>,
      key: "1",
    },
    // {
    //   type: 'divider',
    // },
  ];

  const getTitleStyle = () => {
    if (window.innerWidth < 600) {
      return {
        fontSize: 12,
        lineHeight: 15,
        // color:'red'
      };
    } else {
      return {
        fontSize: 18,
        lineHeight: 22,
      };
    }
  };

  const onRangeChange = (dates, dateStrings) => {
    if (dateStrings) {
      console.log(dateStrings);
      const start = new Date(dateStrings[0]);
      const end = new Date(dateStrings[1]);
      // console.log(isExactMultipleOf24Hours(start, end));
      const DifferenceInHours = isExactMultipleOf24Hours(start, end);

      // Check if the selected range is exactly 24 hours or a multiple of 24 hours
      if (!DifferenceInHours) {
        setError(true);
      } else {
        setError(false);
        setToDate(end);
        setFromDate(start);
        setLoading(true);
        setRefetch(!refetch);
      }
    } else {
      console.log("Clear");
    }
  };

  const rangePresets = [
    {
      label: "Last 7 Days",
      value: [
        dayjs().subtract(7, "days").hour(6).minute(30).second(0),
        dayjs().hour(6).minute(30).second(0),
      ],
    },
    {
      label: "Last 14 Days",
      value: [
        dayjs().subtract(14, "days").hour(6).minute(30).second(0),
        dayjs().hour(6).minute(30).second(0),
      ],
    },
    {
      label: "Last 30 Days",
      value: [
        dayjs().subtract(30, "days").hour(6).minute(30).second(0),
        dayjs().hour(6).minute(30).second(0),
      ],
    },
    {
      label: "Last 90 Days",
      value: [
        dayjs().subtract(90, "days").hour(6).minute(30).second(0),
        dayjs().hour(6).minute(30).second(0),
      ],
    },
  ];

  const getReposnse = async () => {
    // setLoading(true)
    const currentDate = new Date();

    const { from, to } = calculateDateRangeFromDate(currentDate, 1, 1);
    console.log(fromDate)

    const inputData = {
      FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
      ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
    };
    console.log("getReposnse");
    console.log(inputData.ToDate, inputData.FromDate);
    try {
      const res = await makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.LUCAS_SF6VCB_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`, 
      });
      console.log(res)
      console.log(TransformVcbConsumptionToStackedBarChart(res));
      const response = TransformVcbConsumptionToStackedBarChart(res);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Stop loading
    }

    // try {
    //   makeRequest({
    //     type: APIConstants.GET,

    //     //http://20.244.40.160:83/Livedata?FromDate=2024%2F08%2F13%2006%3A30%3A00&ToDate=2024%2F08%2F13%2006%3A30%3A00
    //     url:`${APIConstants.LUCAS_SF6VCB_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`
    //     // url:`${APIConstants.LUCAS_LIVE_GAUGE}?FromDate=2024%2F08%2F13%2006%3A30%3A00&ToDate=2024%2F08%2F13%2006%3A30%3A00`
    //     // token:token,
    //     // body:chartInput
    //   }).then((res) => {
    //     console.log('response')
    //     console.log(res)
    //     console.log(TransformVcbConsumptionToStackedBarChart(res))
    //     const response= TransformVcbConsumptionToStackedBarChart(res)
    //     setData(response)

    //   });
    //   // console.log('function  called')

    // } catch (error) {
    //   // setError(true);
    //   console.log(error);
    // }
  };

  console.log(data);

  useEffect(() => {
    getReposnse();
  }, [refetch]);
  var dataToShow = data && data.series ? data.series : series;
  var categories =
    data && data.categories
      ? data.categories
      : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const theme = props.theme;

  const colors = ["#ab0207","#013220", "#4B0101", "#001F3F", "#B8860B", "#8B4513"];
  return (
    <div className="lg:mt-0 sm:mt-10  w-full xl:w-[100%] shadow-allsides flex flex-col justify-center items-center relative">
      <div
        className="border-b w-full  "
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2
          className={`${
            theme === "dark" ? "text-neutral-100" : "text-neutral-600"
          }  md:text-2xl px-3 font-bold `}
          style={{ margin: 0 }}
        >
          {title}
        </h2>
        <Dropdown
          menu={{
            items,
          }}
          trigger={["click"]}
          arrow
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              <MoreOutlined
                className={`${
                  theme === "dark" ? "text-neutral-100" : "text-neutral-600"
                } p-3 font-extrabold`}
              />
            </Space>
          </a>
        </Dropdown>
      </div>
      {loading ? (
        <div className="flex justify-center items-center w-full h-[200px]">
          <p className="text-white">Loading...</p>
        </div>
      ) : (
        <>
          <ReactECharts
            className={`${
              theme === "dark" ? "bg-slate-950" : "bg-slate-100"
            } lg:mt-0   h-[200px] sm:mt-10  w-full xl:w-[100%] m-auto mb-0  `}
            option={{
              toolbox: {
                show: true,
                feature: {
                  //   dataZoom: {
                  //     yAxisIndex: 'none'
                  //   },
                  //   dataView: { readOnly: false },
                  magicType: { type: ["line", "bar"] },
                  //   restore: {},
                  saveAsImage: {},
                },
              },
              xAxis: {
                type: "category",
                data: categories,
                axisLabel: {
                  interval: "auto",
                  rotate: 45,
                  formatter: function (value) {
                    return value.length > 10
                      ? value.substring(0, 10) + "..."
                      : value;
                  },
                },
              },
              yAxis: {
                type: "value",
                splitLine: {
                  show: false, // This hides the horizontal grid lines
                },
              },
              legend: {
                left: "center",
                right: "2px",
                textStyle: {
                  color: "gray",
                },
              },
              series: dataToShow?.map((seriesItem,index) => ({
                ...seriesItem,
                itemStyle: {
                  color: "#00b6cd", // Makes all bars red
                  // color: colors[index % colors.length]
                },
                label: {
                  show: true,
                  position: "inside",
                  color: theme==='dark'? "#fff":'#fff',
                  fontSize: 10,
                  rotate: 90
                },
              })),
              // title: {
              //   text: title,
              //   left: 'center',
              //   padding: 10,
              //   textStyle: getTitleStyle(),
              // },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
            }}
            // style={style}
            themes={props.theme}
          />
          <Modal
            title={
              <div
                className={`bg-${
                  theme === "dark" ? "slate-950" : "white"
                } text-${theme === "dark" ? "white" : "black"} px-4 py-2`}
              >
                TV mode
              </div>
            }
            centered
            open={open}
            footer={null}
            onCancel={() => setOpen(false)}
            width="1350"
            className="bg-red-700"
            style={{
              padding: 0,
              top: 0,
              backgroundColor: theme === "dark" ? "#1e293b" : "#ffffff",
              color: theme === "dark" ? "#f0f0f0" : "#000000",
            }}
            closeIcon={
              <div
                className={`bg-${
                  theme === "dark" ? "slate-950" : "white"
                } text-${
                  theme === "dark" ? "white" : "black"
                } p-0 mt-0 rounded-full`}
              >
                <CloseOutlined />
              </div>
            }
          >
            <div
              className={`${
                theme === "dark" ? "bg-slate-950" : "bg-slate-100"
              }`}
            >
              <ReactECharts
                className={`${
                  theme === "dark" ? "bg-slate-950" : "bg-slate-100"
                } lg:mt-0   h-full sm:mt-10  w-full xl:w-[100%] m-auto mb-0 p-2   `}
                option={{
                  toolbox: {
                    show: true,
                    feature: { 
                      //   dataZoom: {
                      //     yAxisIndex: 'none'
                      //   },
                      //   dataView: { readOnly: false },
                      magicType: { type: ["line", "bar"] },
                      //   restore: {},
                      saveAsImage: {},
                    },
                  },
                  xAxis: {
                    type: "category",
                    data: categories,
                    axisLabel: {
                      interval: "auto",
                      rotate: 45,
                      formatter: function (value) {
                        return value.length > 10
                          ? value.substring(0, 10) + "..."
                          : value;
                      },
                    },
                  },
                  yAxis: {
                    type: "value",
                    splitLine: {
                      show: false, // This hides the horizontal grid lines
                    },
                  },
                  legend: {
                    left: "center",
                    right: "2px",
                    textStyle: {
                      color: "gray",
                    },
                  },
                  series: dataToShow,
                  title: {
                    text: title,
                    left: "2px",
                    padding: 10,
                    textStyle: getTitleStyle(),
                  },
                  tooltip: {
                    trigger: "axis",
                    axisPointer: {
                      type: "shadow",
                    },
                  },
                }}
                style={{ height: "900px", width: "1300px" }} 
                themes={props.theme}
              />
            </div>
          </Modal>
          {/* <Modal
        title={"TV mode"}
        centered
        open={open}
        footer={null}
        onCancel={() => setOpen(false)}
        // width={1000}
        // height={700}
        className=' p-0 m-0'
        width="100vw" // Full width
        style={{ padding: 0, top: 0 }} // Remove padding and set to top
        
      >
         <ReactECharts className={`${theme==='dark'?"bg-slate-950":'bg-slate-100'} lg:mt-0   h-full sm:mt-10  w-full xl:w-[100%] m-auto mb-0   `}
        option={{
          toolbox: {
            show: true,
            feature: {
            //   dataZoom: {
            //     yAxisIndex: 'none'
            //   },
            //   dataView: { readOnly: false },
              magicType: { type: ['line', 'bar'] },
            //   restore: {},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            data: categories,
            axisLabel: {
              interval: 'auto', 
              rotate: 45, 
              formatter: function (value) {
                  return value.length > 10 ? value.substring(0, 10) + '...' : value;
              }
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: false, // This hides the horizontal grid lines
            },
          },
          legend: {
            left: 'center',
            right: '2px',
            textStyle: {
              color: 'gray', 
            },
          },
          series: dataToShow,
          title: { 
            text: title,
            left: '2px',
            padding: 10,
            textStyle: getTitleStyle(),
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          }
        }}
        style={{ height: '90vh', width: '95vw' }} // Full width and height for the chart
        themes={props.theme}
         />
      </Modal> */}
        </>
      )}

      <div className="flex justify-center items-center w-full pt-[0px]">
        <p className="bg-transparent w-fit p-2 md:mb-2 text-white   ">
          <RangePicker
            presets={[
              {
                label: (
                  <span aria-label="Current Time to End of Day">Now ~ EOD</span>
                ),
                value: () => [dayjs(), dayjs().endOf("day")],
              },
              ...rangePresets,
            ]}
            showTime
            format="YYYY/MM/DD HH:mm:ss"
            defaultValue={[defaultFromDate, defaultToDate]}
            className={`customRangePicker ${error ? "errorInDate" : ""}  ${
              theme === "dark"
                ? "customRangePicker-dark"
                : "customRangePicker-light"
            }`}
            onChange={onRangeChange}
            disabledDate={(current) => {
              return current && current > dayjs().endOf("day");
            }}
          />
          {error && (
            <p className="text-white font-bold border-b-2 border-red-500">
              The selected time range must be at least 24 hours and a multiple
              of 24 hours.
            </p>
          )}
        </p>
      </div>
    </div>
  );
}
